export default class CreateRateSourceRequest {
    name: string = '';
    currentInterestRate: number = 0;
    baseRate: boolean = false;
    baseRateSourceId: string = undefined;
    rate: number = 0;
}